import { DokumentStavkaInlineUpdateComponent } from './dokument/dokument-stavka-inline-update.component';
import { DokumentStavkaModalUpdateComponent } from './dokument/dokument-stavka-modal-update.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatComponent } from './mat.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeComponent } from './home/home.component';
import { MatRoutingModule } from './mat-routing.module';
import { YtNgFrameworkModule, ModalContainerService, ModalService } from 'yt-ng-framework';
import { LookupsModule } from '../lookups/lookups.module';
import { DokumentTabsComponent } from './dokument/dokument-tabs.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DokumentTabUpdateComponent } from './dokument/dokument-tab-update.component';
import { DokumentUpdateComponent } from './dokument/dokument-update.component';
import { DokumentStavkaUpdateComponent } from './dokument/dokument-stavka-update.component';
import { DokumentStavkaUpdateContainer } from './dokument/dokument-stavka-update-container.component';
import { KarticaMpArtiklaComponent } from './kartica-mp-artikla/kartica-mp-artikla.component';
import { KarticaMpArtiklaUkupnoComponent} from './kartica-mp-artikla/kartica-mp-artikla-ukupno.component';
import { PrometRobeZaKomitentaPoArtiklimaComponent} from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima.component';
import { PrometKaseComponent } from './_reports/promet-kase/promet-kase.component';
import { RekapitulacijaIzlazaPoArtiklimaComponent } from './rekapitulacija-izlaza-po-artiklima/rekapitulacija-izlaza-po-artiklima.component';
import { PrometRobeZaKomitentaPoArtiklimaAnalitikaComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima-analitika.component';
import { PrometRobeZaKomitentaPoArtiklimaModalAnalitikaComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima-modal-analitika.component';
import { KarticaMpArtiklaModalComponent} from './kartica-mp-artikla/kartica-mp-artikla-modal.component';
import { PrometRobeZaKomitentaPoArtiklimaUkupnoComponent } from './promet-robe-za-komitenta-po-artiklima/promet-robe-za-komitenta-po-artiklima-ukupno.component';
import { KepComponent } from './_reports/kep/kep.component';

@NgModule({
  imports: [
    MatRoutingModule,
    LookupsModule
    , NgbModule
    , TranslateModule
  ],
  declarations: [HomeComponent, MatComponent
    , DokumentTabsComponent
    , DokumentTabUpdateComponent
    , DokumentUpdateComponent
    , DokumentStavkaUpdateComponent
    , DokumentStavkaModalUpdateComponent
    , DokumentStavkaUpdateContainer
    , DokumentStavkaInlineUpdateComponent
    , KarticaMpArtiklaComponent
    , KarticaMpArtiklaUkupnoComponent
    , KarticaMpArtiklaModalComponent
    , PrometRobeZaKomitentaPoArtiklimaComponent
    , PrometKaseComponent
    , RekapitulacijaIzlazaPoArtiklimaComponent
    , PrometRobeZaKomitentaPoArtiklimaAnalitikaComponent
    , PrometRobeZaKomitentaPoArtiklimaModalAnalitikaComponent
    , PrometRobeZaKomitentaPoArtiklimaUkupnoComponent
    , KepComponent
  ]
  , exports: [
    DokumentTabsComponent
    , DokumentTabUpdateComponent
    , DokumentUpdateComponent
    , DokumentStavkaUpdateComponent
    , KarticaMpArtiklaUkupnoComponent
    , KarticaMpArtiklaComponent
  ],
  // entryComponents: [
  //   DokumentStavkaModalUpdateComponent
  //   , KarticaMpArtiklaUkupnoComponent
  //   , KarticaMpArtiklaComponent
  // ],
  providers: [
    ModalContainerService,
    ModalService
  ]
})
export class MatModule { }
